import { http } from '@/shared/httpWrapper.js';
import { AttributeDefinition } from '@/shared/helpers/api/types/entities.ts';
import {
    genericViewDefinition,
    getAttributeDefinitions,
    ViewDefinitionDTO,
    DatabaseInformationSchemaColumn
} from '@/shared/helpers/api';

function enhanceColumnDefinitions(tableDefinition: ViewDefinitionDTO, attributeDefinitions: AttributeDefinition[]) {
    const getFullType = (c: DatabaseInformationSchemaColumn) => {
        if (c.data_type === 'nvarchar') {
            if (c.character_maximum_length === -1) {
                return 'nvarchar(max)';
            }
            return `nvarchar(${c.character_maximum_length})`;
        }
        return c.data_type;
    };

    tableDefinition.columns.forEach(c => {
        const data_type_full = getFullType(c);
        let typeSuffix = '';

        if (c.column_name === 'Id') {
            c.icon = 'key';
            c.iconTooltip = 'Primary key';
            typeSuffix = 'PK, ';
        } else if (c.column_name === 'Scope') {
            c.icon = 'group';
            c.iconTooltip = 'Scope is used to group, and Identity is unique in a Scope.';
        } else if (c.column_name.endsWith('_ID')) {
            const attributeDefinition = attributeDefinitions.find(x => x.name === c.column_name.slice(0, -3))!;
            c.icon = 'key-link';
            c.iconTooltip = `Foreign key to ${attributeDefinition.referenceLibraryName}`;
            typeSuffix = 'FK, ';
        }

        c.typeSuffix = `${typeSuffix}${data_type_full}, ${c.is_nullable === 'NO' ? 'not null' : 'null'}`;
    });
}

export type LibraryDefinition = {
    view: ViewDefinitionDTO;
    attributes: AttributeDefinition[];
    isOpen: boolean;
};

export async function loadLibraryDefinition(lib: string): Promise<LibraryDefinition> {
    const [
        viewDefinitionResult,
        attributeDefinitionsResult
    ] = await Promise.all([
        genericViewDefinition(http, lib),
        getAttributeDefinitions(http, lib)
    ]);

    enhanceColumnDefinitions(viewDefinitionResult, attributeDefinitionsResult);

    return {
        view: viewDefinitionResult,
        attributes: attributeDefinitionsResult,
        isOpen: true
    };
}
